<script>
import Layout from "../../layouts/auth";
import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import AuthApi from "@/services/auth-api";
import Vue from 'vue'
import UsersApi from "@/services/users-api";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, NprogressContainer,FormWizard, TabContent,WizardStep},
  data() {
    return {
      email: "",
      password: "",
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      forgetPasswordisClicked:false,
      newPassword:"",
      confPassword:"",
      username:"",
      errorMessage:"",
      showErrorMesage:false,
      tryingToCreateCode:false,
      code:"",
      showSecondErrorMessage:false,
      secondErrorMessage:"",
      createNewAccountClicked:false,
      newAccount:{fullName:null,phone:null,email:null,taxRef:null,patentFile:null,address:null,companyName:null},

      addAcountRequestErrorMsg: null,
      createNewAccountSuccess: false,

    };
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true;
      this.isAuthError = false;
      // Reset the authError if it existed.
      this.authError = null;
      return (
        this.logIn({
          email: this.email,
          password: this.password
        })
          // eslint-disable-next-line no-unused-vars
          .then(token => {

            
            
            this.tryingToLogIn = false;
            this.isAuthError = false;

            // Redirect to the originally requested page, or to the home page
            if (this.$route.query.redirectFrom == "/logout") {
              this.$router.push({ name: "default" });
            } else {
              this.$router.push(
                this.$route.query.redirectFrom || { name: "default" }
            );
            }
          })
          .catch(error => {

            this.tryingToLogIn = false;
            this.authError = error ? error : "";
            this.isAuthError = true;
          })
      );
    },

    openForgetPassword(){
      this.forgetPasswordisClicked=true
      this.newPassword=""
      this.confPassword=""
      this.username=""
      this.errorMessage=""
      this.showErrorMesage=false
      this.tryingToCreateCode=false
      this.code=""
      this.showSecondErrorMessage=false
      this.secondErrorMessage=""
      this.isAuthError=false
    },

    openCreateNewAccount() {
      this.createNewAccountClicked=true
    },


    _handleError(error) {
        this.errorMessage=error
        this.showErrorMesage=true
    },

    _handleSecondError(error) {
        this.secondErrorMessage=error
        this.showSecondErrorMessage=true
    },

      handleFileUpload(event) {
        const input = event.target;
        if (input.files.length > 0) {
          const fileName = input.files[0].name;
          input.nextElementSibling.innerText = fileName;
          this.newAccount.patentFile = input.files[0];
        }
      },

    addAccountRequest() {

       this.addAcountRequestErrorMsg = null;
        // Validate required fields
        if (!this.newAccount.fullName || !this.newAccount.companyName) {
          this.addAcountRequestErrorMsg = "Veuillez remplir le nom & prénom et le nom de société.";
          return;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(this.newAccount.email)) {
          this.addAcountRequestErrorMsg = "Veuillez saisir une adresse e-mail valide.";
          return;
        }

        if (!this.newAccount.phone) {
          this.addAcountRequestErrorMsg = "Veuillez saisir un numéro de téléphone.";
          return;
        }

        const phone = this.newAccount.phone.replace(/\s+/g, '');
        if(!/^\+?\d{8,15}$/.test(phone)){
             this.addAcountRequestErrorMsg = "Veuillez entrer un numéro de téléphone valide.";
            return;
        }
        
          // Create a FormData object to hold the account request data
          // This allows us to send files and other data in a single request
          // Note: Ensure that the backend API is set up to handle FormData correctly
          // and that it expects the fields in the same format as below.
          // If the backend expects JSON, you may need to adjust this accordingly.
          // If the backend expects a file upload, ensure that the field names match what the backend
          // is looking for.      
      
      const formData = new FormData();

        if (this.newAccount.fullName) {
          formData.append('fullName', this.newAccount.fullName);
        }

        if (this.newAccount.email) {
          formData.append('email', this.newAccount.email);
        }

        if (this.newAccount.address) {
          formData.append('address', this.newAccount.address);
        }

        if (this.newAccount.companyName) {
          formData.append('companyName', this.newAccount.companyName);
        }

        if (this.newAccount.taxRef) {
          formData.append('taxRef', this.newAccount.taxRef);
        }

        if (this.newAccount.phone) {
          formData.append('phone', this.newAccount.phone);
        }

        if (this.newAccount.patentFile) {
          formData.append('patentFile', this.newAccount.patentFile);
        }


        UsersApi.addAccountRequest(formData)
        .then(
              (result) => {
            if (result) {
              Vue.prototype.$snotify.success('Votre demandée est ajoutée avec succès')
              this.newAccount={fullName:null,phone:null,email:null,taxRef:null,patentFile:null,address:null,companyName:null}
              
              this.createNewAccountSuccess = true;
              
              //this.createNewAccountClicked=false;
            }
              }
            )
            .catch((error) => {
               this.addAcountRequestErrorMsg = error;
            })
            .finally(()=>{
            })
      },

    createCode () {
      return new Promise((resolve, reject) => {
          AuthApi.createCode(this.username,this.newPassword,this.confPassword)
          .then((result) => {
              resolve(result);
          }, (error) => {
              reject(this._handleError(error));
          });
      });
    },

    resetPassword () {
      return new Promise((resolve, reject) => {
          AuthApi.resetPassword(this.username,this.code)
          .then((result) => {
              resolve(result);
          }, (error) => {
              reject(this._handleSecondError(error));
          });
      });
    },

  

  }
};
</script>

<style lang="scss">
  
  #nprogress .bar {
    background: #d90100;// #f2b44d;
    height: 4px;
  }

  #nprogress .spinner-icon {
  border: solid 4px transparent;
  border-top-color: #d90100;
  border-left-color: #d90100;
  }

  #nprogress .peg {
  box-shadow: 0 0 10px grey, 0 0 5px grey;
  opacity: 1.0;
  }

.hr-text {
    line-height: 1em;
    position: relative;
    outline: 0;
    border: 0;
    color: black;
    text-align: center;
    height: 1.5em;
    opacity: .5;
    &:before {
      content: '';
      // use the linear-gradient for the fading effect
      // use a solid background color for a solid bar
      background: linear-gradient(to right, transparent, #818078, transparent);
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: 1px;
    }
    &:after {
      content: attr(data-content);
      position: relative;
      display: inline-block;
      color: black;
      padding: 0 .5em;
      line-height: 1.5em;
      // this is really the only tricky part, you need to specify the background color of the container element...
      color: #818078;
      background-color: #FCFCFA;
    }
  }

</style>

<template>
  <Layout class="nprogress-container">
     <div class="row justify-content-center d-xs-none" style="opacity:0.95">
      <nprogress-container></nprogress-container>

      <div class="" :class="!forgetPasswordisClicked && createNewAccountClicked ? 'col-lg-8 col-md-12 col-xl-8' : 'col-lg-8 col-md-8 col-xl-8'">
        <div class="card border-warning overflow-hidden" style=" border-radius: 5px; ">

          <div class="bg-white">
            <div class="row pl-4 pr-4">
              <!-- <div class="col-7">
              </div> -->
              <div class="col-12 text-center pt-4 align-self-end">
                <a href="/">
                  <img src="@/assets/images/logo-dark.png" alt class="img-fluid" />
                </a>
              </div>
            </div>

            <div class="row pr-4 pt-4 pl-4">
              <div class="col-12 text-right text-center">
                <div class="text-primary pl-4 pr-4 pb-2">
                  <h5 class="text-primary text-center font-weight-bold text-right">Commerce de Pièces Auto en Gros</h5>
                  <span class="text-muted text-center">Tél.: +216 74 204 700,  Email: contact@sopiq.tn</span><br>
                </div>
              </div>
            </div>

            
          </div>

          <div class="card-body pt-0">
            
            

            <!-- <hr/> -->

            <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{authError}}</b-alert>

            <div v-if="forgetPasswordisClicked && !createNewAccountClicked">
              <form-wizard  color="#fec235" nextButtonText="Suivant" finish-button-text="Terminer" @on-complete="forgetPasswordisClicked=false">
                  <div slot="prev" scope="props" class="d-none">                      
                  </div>
                  <template slot="step" slot-scope="props">
                    <wizard-step :tab="props.tab"
                    :transition="props.transition"
                    
                    :index="props.index">
                    </wizard-step>
                  </template>
                <tab-content icon="mdi mdi-account-circle"  :before-change="createCode">
                  <div class="row mb-4">
                    <div class="col-12">
                        <b-alert v-show="showErrorMesage" show variant="danger">{{this.errorMessage}}</b-alert>

                        <label class="mb-2" >Adresse Mail</label>
                        <input
                          class="form-control"
                          v-model="username"
                          type="text"
                          placeholder="Adresse Mail"
                          autocomplete="off"
                        />
                        <label class="mb-2 mt-4" for="pwd">Nouveau Mot de passe</label>
                        <input
                          class="form-control"
                          id="pwd"
                          v-model="newPassword"
                          type="password"
                          placeholder="Nouveau Mot de passe"
                          autocomplete="off"
                        />
                        <label class="mb-2 mt-4" for="confpwd">Retapez le nouveau mot de passe</label>
                        <input
                          class="form-control"
                          id="confpwd"
                          v-model="confPassword"
                          type="password"
                          placeholder="Mot de Passe de Confirmation"
                          autocomplete="off"
                        />
                    </div>
                  </div>
                </tab-content>
                <tab-content icon="mdi mdi-lock" :before-change="resetPassword" >
                  <div class="row">
                    <div class="col-12">
                        <b-alert v-show="showSecondErrorMessage" show variant="danger">{{this.secondErrorMessage}}</b-alert>
                        <div class="row mb-4">
                          <div class="col-12 text-center text-danger">
                          <i class="bx bx-hourglass bx-spin mr-2"></i>Un code a été envoyé à l'adresse <span class="font-weight-bold">{{this.username}}. </span> Ce code expire dans <span class="font-weight-bold">15 minutes</span>
                          </div>
                        </div>
                        <input
                          class="form-control mb-4"
                          v-model="code"
                          type="text"
                          placeholder="Saisir le Code"
                          autocomplete="off"
                        />
                    </div>
                  </div>
                </tab-content>
                <tab-content icon="mdi mdi-checkbox-marked-circle-outline">
                  <div class="row mb-4">
                    <div class="col-12">
                      <div class="text-center">
                        <h2 class="mt-0">
                          <i class="mdi mdi-check-all text-success"></i>
                        </h2>
                        <h3 class="mt-0">Félicitations !</h3>

                        <p class="w-75 mb-2 mx-auto">
                          Votre mot de passe a été réinitialisé avec succés.
                        </p>

                      </div>
                    </div>
                  </div>
                </tab-content>
              </form-wizard>
              <div class="row">
                <div class="col-12 text-muted text-center" >
                  <i class="mdi mdi-lock mr-1"></i> Vous vous en souvenez ?               
                  <div
                  style="cursor:pointer;"
                  @click="forgetPasswordisClicked=false"
                  class="font-weight-medium text-primary"
                  >Connectez-vous ici</div
                > 
                </div>
              </div>
            </div>

            
            <!-- PRO ACCOUNT CREATION -->
            <div v-else-if="!forgetPasswordisClicked && createNewAccountClicked" >
                <div v-if="!createNewAccountSuccess">
                        <div   class="row  mt-1 pt-4 ">
                        <div class="col-12 text-right">
                          <div class="text-primary pr-2 pl-0 pb-2">
                            <h5 class="text-primary font-weight-bold font-size-20 text-center">
                              <span class="d-none d-sm-inline">Créer un compte professionnel ?</span>
                              <span class="d-sm-none">Créer un compte pro ?</span>
                            </h5>
                          </div>
                        </div>
                        </div>

                        <div class="row mt-4">
                                    <div class="col-12">
                                      <span class="text-secondary font-size-12" style="text-align:justify;">
                                        Envoyer nous le nom de votre société, votre numéro de téléphone, adresse mail 
                                        et <u>demandez votre inscription à l'espace des clients professionnels.</u>
                                      </span>
                                    </div>
                                </div>

                                <b-form  class="pt-4 pb-2 pr-4 pl-4 mt-2">

                                  <div class="form-row">
                                    <div class="form-group col-12 col-sm-6">
                                      <label class="text-dark">Nom & Prénom</label>
                                      <b-form-input
                                        v-model="newAccount.fullName"
                                        class="font-size-16 text-dark border border-dark"
                                        placeholder="Nom & Prénom"
                                        autocomplete="off"
                                      ></b-form-input>
                                    </div>

                                    <div class="form-group col-12 col-sm-6">
                                      <label class="text-dark">Nom de société</label>
                                      <b-form-input
                                        v-model="newAccount.companyName"
                                        class="font-size-16 text-dark border border-dark"
                                        placeholder="Nom de société"
                                        autocomplete="off"
                                      ></b-form-input>
                                    </div>
                                  </div>

                                  <div class="form-row">
                                    <div class="form-group col-12 col-sm-6">
                                      <label class="text-dark">Adresse e-mail</label>
                                      <b-form-input
                                        v-model="newAccount.email"
                                        class="font-size-16 text-dark border border-dark"
                                        placeholder="Adresse e-mail"
                                        type="email"
                                        autocomplete="off"
                                      ></b-form-input>
                                    </div>

                                    <div class="form-group col-12 col-sm-6">
                                      <label class="text-dark">Téléphone</label>
                                      <b-form-input
                                        v-model="newAccount.phone"
                                        class="font-size-16 text-dark border border-dark"
                                        placeholder="Numéro de téléphone"
                                        autocomplete="off"
                                      ></b-form-input>
                                    </div>
                                  </div>

                                  <div class="form-row">
                                    

                                    <div class="form-group col-12 col-sm-6">
                                      <label class="text-dark">Adresse</label>
                                      <b-form-input
                                        v-model="newAccount.address"
                                        class="font-size-16 text-dark border border-dark"
                                        placeholder="Adresse"
                                        autocomplete="off"
                                      ></b-form-input>
                                    </div>

                                    <div class="form-group col-12 col-sm-6">
                                      <label class="text-dark">Matricule Fiscale (MF)</label>
                                        <b-form-input
                                            v-model="newAccount.taxRef"
                                            class="font-size-16 text-dark border border-dark"
                                            placeholder="Ex : 1234567A/A/A/123"
                                            autocomplete="off"
                                        ></b-form-input>
                                    </div>  
                                  </div>

                                  <div class="form-group">
                                    <label class="text-dark">
                                      Patente (Image)
                                    </label>
                                    <div class="custom-file">
                                      <input
                                          type="file"
                                          class="custom-file-input"
                                          id="patentFile"
                                          @change="handleFileUpload"
                                          accept=".jpg,.jpeg,.png"
                                        />
                                        <label class="custom-file-label" for="patentFile">Choisir fichier</label>


                                    </div>
                                    <small class="form-text text-muted mt-1">
                                      Formats acceptés : JPG, JPEG, PNG.
                                    </small>
                                  </div>


                                  <div class="mt-4 mb-2 text-right">
                                    <span v-if="addAcountRequestErrorMsg" class="text-danger">{{ addAcountRequestErrorMsg }}</span>
                                  </div>

                                  <div class="mt-2 mb-2">

                                    <div class="row">
                                      <div class="col-12 col-lg-4 pr-lg-2 d-none d-lg-block">
                                          <b-button variant="light"
                                            @click="createNewAccountClicked=false"
                                            class="btn-block text-dark font-size-20">
                                            Annuler
                                          </b-button>
                                      </div>

                                      <div class="col-12 col-lg-8 pt-2 pt-lg-0 pl-lg-2">
                                        <b-button variant="warning"
                                            @click="addAccountRequest()"
                                            class="btn-block font-weight-bold text-white font-size-20">
                                            Envoyer <span class="d-none d-lg-inline">la demande</span>
                                          </b-button>
                                      </div>
                                    </div>

                                    
                                  </div>

                                </b-form>

                    
                  </div>
                   <div v-else class="text-center pt-4 pb-4">
                       
                        <p class="mt-4 mb-2 font-size-16 text-primary font-weight-bold">
                          Votre demande de création de compte a été envoyée avec succès. 
                          Nous vous contacterons bientôt pour finaliser votre inscription.
                        </p>

                        <b-button variant="outline-dark" @click="createNewAccountClicked=false" class="mt-3 font-weight-bold font-size-14">
                          Retour à la connexion
                        </b-button>
                  </div>

            

      

              
            </div>

            <b-form  v-else class="p-lg-5 p-0" @submit.prevent="tryToLogIn">
              <b-form-group class="text-primary pt-2" id="input-group-1"  label-for="input-1">
                <b-form-input class="font-size-16" id="input-1" v-model="email" type="email" placeholder="LOGIN"></b-form-input>
              </b-form-group>

              <b-form-group class="text-primary pt-2" id="input-group-2"  label-for="input-2">
                <b-form-input
                class="font-size-16"
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="MOT DE PASSE"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
              
              <div class="mt-4">

                <!-- <div class="row">
                  <div class="col-6 my-auto">
                        <a href="javascript:void(0)" @click="openCreateNewAccount()" class="" >
                                              <span class="text-secondary font-size-14">Demander un compte client</span>
                        </a>
                  </div>

                  <div class="col-6"> -->
                                    <b-button type="submit" variant="warning" class="btn-block text-white mt-5 font-weight-bold font-size-20">Connecter</b-button>

                  <!-- </div> -->

                <!-- </div> -->

                

              </div>
              <!-- <div class="mt-4 text-center text-info font-size-15">
              </div> -->
              <!-- <div class="mt-3 text-center">
                <div class="text-muted" @click="openForgetPassword" style="cursor: pointer">
                  <i class="mdi mdi-lock mr-1"></i> Vous avez oublié votre mot de passe ?
                </div>
              </div> -->
            </b-form>


            <!-- <hr class="hr-text" data-content="OU"  v-if="!forgetPasswordisClicked && !createNewAccountClicked"/> -->

            <div class="row  mb-4"  v-if="!forgetPasswordisClicked && !createNewAccountClicked">


              <div class="col-lg-2 col-md-12 col-sm-12 pt-lg-0 pt-4 text-center"></div>

              <div class="col-lg-8 col-md-12 col-sm-12 pt-lg-0 pt-4 text-center">

                <span class="font-size-14">Nouveau client ? 
                  <strong @click="openCreateNewAccount()" class="text-warning" style="cursor:pointer;">
                    <u>Demandez votre compte</u>
                  </strong>
                   et commandez en ligne </span>

                  <!-- <b-button variant="outline-primary" @click="openCreateNewAccount()" class="" >
                      <span class="text-secondary font-size-14">Demander un compte client</span>
                  </b-button> -->

              </div>
            </div>



          </div>
          <!-- end card-body -->

          <!--<div class="card-footer bg-transparent border-top">
            <div class="contact-links d-flex font-size-20">
              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Site web" href="https://www.sia-am.com/" style="cursor: pointer" target="_blank" >
                  <i class="fas fa-globe text-muted"></i>
                </a>
              </div>

              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Facebook" href="https://www.facebook.com/AmortisseursTunisie" style="cursor: pointer" target="_blank" >
                  <i class="fab fa-facebook-square text-muted"></i>
                </a>
              </div>

              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Linkedin" href="https://www.linkedin.com/company/sia-tunisia/" style="cursor: pointer" target="_blank">
                  <i class="fab fa-linkedin text-muted"></i>
                </a>
              </div>
                
            </div>
          </div> -->
          
        </div>
        <!-- end card -->

          <div class="mt-5 font-weight-bold font-size-12 text-light text-center">
            
            <p>
              <a href="http://www.sopiq.tn"  target="_blank" class="text-white">
              © {{new Date().getFullYear()}} - www.SOPIQ.tn
              <br>Avenue Farhat Hached 3000, Sfax, Tunisie
              </a>
            </p>
          </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
